
import { defineComponent, reactive, toRefs } from 'vue'
export default defineComponent({
    setup() {
        const state:any=reactive({
            centerDialogVisible:true
        })
        const methods:any=reactive({

        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
